module.exports = __webpack_public_path__ + "static/img/Ring.de2a54c6.png";